export const NO_FUNCTION = "noFunction";
export const SUPERIOR = "superior";
export const ACCOUNTING = "accounting";
